module.exports = __webpack_public_path__ + "assets/img/17.1d97d044.png";